export default __webpack_public_path__ + "static/media/information--subway--g1.11a232ac.png";